/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByUserIntentKind = (typeof GroupByUserIntentKind)[keyof typeof GroupByUserIntentKind];

export const GroupByUserIntentKind = {
  user_intent: 'user_intent',
} as const;
